import React, {useContext} from 'react';
import './Home.scss'; // Import the CSS file here
// import Footer from '../pageComponents/Footer';
import Navigation from '../pageComponents/Navigation';
import Header from '../pageComponents/Header';
import { LanguageContext } from "../language/LanguageContext";


const Home = () => {
    const { dictionary } = useContext(LanguageContext);

    return (
        <>
            <Header />
            <Navigation/>
            <div className='home-image-holder main'>
                <div className='img-holder'>
                    {dictionary && dictionary.hint_active === "true" && (
                        <div className='text-holder' dangerouslySetInnerHTML={{ __html: dictionary.hint }} />
                    )}
                    <img src={`${process.env.PUBLIC_URL}/images/1403_1920.jpg`} alt="Home" />
                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default Home;